export enum JobPostingCompensationTypes {
    hourly = 'hourly',
    daily = 'daily',
    weekly = 'weekly',
    monthly = 'monthly',
    yearly = 'yearly',
}
